import CloseIcon from '@mui/icons-material/Close';
import {
  Box,
  Dialog,
  DialogContent,
  IconButton,
  Tooltip,
  Typography
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import * as React from 'react';

export default function MaterialModal(props) {
  const { closeButtonTooltip, disableClose } = props;
  const theme = useTheme();

  const [modalWidth, setModalWidth] = React.useState(400);
  const [modalHeight, setModalHeight] = React.useState(300);
  
  const [resizing, setResizing] = React.useState(false);

  let passedStyles = { container: {}, content: {} }
  if (props.styleOverrides){
    passedStyles.container = props?.styleOverrides?.container || {}
    passedStyles.content = props?.styleOverrides?.content || {}
  }

  const handleMouseMove = (e) => {
    if (resizing) {
      setModalHeight(modalHeight - e.clientY);
      setModalWidth(modalWidth - e.clientX);
    }
  };

  const handleMouseUp = () => {
    setResizing(false);
  };

  return (
      <Dialog
        onClose={props.handleDialogClose}
        open={props.open}
        sx={{ padding: '20px', ...passedStyles.container, zIndex: theme?.custom?.dialogZIndex }}
        >
        <Box
          sx={{
            alignItems: 'center',
            borderTopLeftRadius: '4px',
            borderTopRightRadius: '4px',
            display: 'flex',
            justifyContent: 'space-between',
            padding: '11px 24px',
            backgroundColor: "#F4F4F4"
          }}
          onMouseMove={handleMouseMove}
          onMouseUp={handleMouseUp}
          >
          <Typography variant="h5">
            {props.title} 
          </Typography>
          <Tooltip title={closeButtonTooltip}>
            <Box>
              <IconButton
                onClick={props.handleDialogClose}
                disabled={disableClose}
                sx={{
                  "&.Mui-disabled": {
                    color: "rgba(255, 255, 255, 0.5)",
                  },
                }}
              >
                <CloseIcon
                  sx={{ color: "inherit" }}
                  fontSize="medium"/>
              </IconButton>
            </Box>
          </Tooltip>
          
        </Box>
        <Box
          sx={{
            borderBottom: '1px solid #c2c2c2',
          }}
        >
        </Box>
        <DialogContent sx={{ padding: '24px', ...passedStyles.content, borderBottomLeftRadius: '4px', borderBottomRightRadius: '4px' }}>
          {props.children}
        </DialogContent>
      </Dialog>
  );
};

MaterialModal.defaultProps = {
	closeButtonTooltip: "Close",
	disableClose: false,
};
